'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by li on 2016/4/8.
                    */

// import Carousel from 'nuka-carousel';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterCarousel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FooterCarousel, _Component);

  function FooterCarousel() {
    (0, _classCallCheck3.default)(this, FooterCarousel);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(FooterCarousel).apply(this, arguments));
  }

  (0, _createClass3.default)(FooterCarousel, [{
    key: 'render',
    value: function render() {
      // const Decorators = [ {
      //  component: React.createClass({
      //    getIndexes(count, inc) {
      //      const arr = [];
      //      for (let index = 0; index < count; index += inc) {
      //        arr.push(index);
      //      }
      //      return arr;
      //    },
      //    getListStyles() {
      //      return {
      //        position: 'relative',
      //        margin: 0,
      //        top: -10,
      //        padding: 0
      //      };
      //    },
      //    getListItemStyles() {
      //      return {
      //        listStyleType: 'none',
      //        display: 'inline-block'
      //      };
      //    },
      //    getButtonStyles(active) {
      //      return {
      //        border: 0,
      //        color: 'black',
      //        cursor: 'pointer',
      //        marginLeft: 10,
      //        outline: 0,
      //        fontSize: 10,
      //        background: active ? 'red' : '#9a9a9a',
      //        display: 'block',
      //        height: '15px',
      //        width: '15px',
      //        borderRadius: '30px'
      //      };
      //    },
      //    render() {
      //      const self = this;
      //      const indexes = this.getIndexes(self.props.slideCount, self.props.slidesToScroll);
      //      return (
      //        <ul style={self.getListStyles()}>
      //          {
      //            indexes.map((index)=> {
      //              return (
      //                <li style={self.getListItemStyles()} key={index}>
      //                  <a
      //                    style={self.getButtonStyles(self.props.currentSlide === index)}
      //                    onClick={self.props.goToSlide.bind(null, index)}>
      //                  </a>
      //                </li>
      //              );
      //            })
      //          }
      //        </ul>
      //      );
      //    }
      //  }),
      //  position: 'BottomCenter'
      // } ];
      var styles = require('./FooterCarousel.scss');
      var settings = {
        dots: true,
        infinite: true,
        arrows: false,
        dotsClass: 'slick-dots ' + styles.dotsClass,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 3
      };
      return _react2.default.createElement(
        _reactSlick2.default,
        settings,
        this.props.children
      );
    }
  }]);
  return FooterCarousel;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.array.isRequired
}, _temp);
exports.default = FooterCarousel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FooterCarousel/FooterCarousel.js
 ** module id = 1337
 ** module chunks = 0
 **/